import React, { FC, useCallback, useContext } from 'react'
import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from '../../../../../../components/Dashboard/Modal'
import { InputField } from '../../../../../../components/Dashboard/InputField'
import { confirmReceivedAmountRequest, openConfirmReceivedAmountPopup } from '../../../../../../store/actions'
import {
  confirmReceivedAmountDataSelector,
  isLoadingConfirmReceivedAmountSelector,
} from '../../../../../../store/selectors'
import { AppStateContext } from '../../../../../../components/Context'
import { Loader } from '../../../../../../components/Loader'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
}))

interface IAddNewWalletPopup {
  isOpen: boolean
  modalClose?: () => void
}

type Inputs = {
  amount: string
}

export const FirstTimeDepositPopup: FC<IAddNewWalletPopup> = ({ isOpen, modalClose }) => {
  const classes = useStyles()
  const { getAuthToken } = useContext(AppStateContext)
  const token = getAuthToken()
  const dispatch = useDispatch()

  const isLoadingConfirmReceivedAmount = useSelector(isLoadingConfirmReceivedAmountSelector)
  const confirmReceivedAmountData = useSelector(confirmReceivedAmountDataSelector)

  const formMethods = useForm<Inputs>({
    mode: 'onBlur',
    // resolver,
  })
  const { getValues, reset } = formMethods

  const onClose = useCallback(() => {
    dispatch(openConfirmReceivedAmountPopup({ open: false }))
    reset()
  }, [dispatch, reset])

  const handleConfirm = useCallback(() => {
    if (token && confirmReceivedAmountData.walletId)
      dispatch(
        confirmReceivedAmountRequest({
          walletId: Number(confirmReceivedAmountData.walletId),
          amount: getValues().amount,
        }),
      )
  }, [token, dispatch, confirmReceivedAmountData.walletId, getValues])

  return (
    <Modal
      title={'Confirm Received Amount'}
      isOpen={isOpen}
      modalClose={modalClose || onClose}
      isSubmit={true}
      onSubmit={handleConfirm}
      submitTitle={'Confirm'}
    >
      <FormProvider {...formMethods}>
        <Grid container className={classes.container}>
          {/* {confirmReceivedAmountData && confirmReceivedAmountData?.data?.success ? ( */}
          {/*   <Grid item xs={12} display={'flex'} alignItems={'center'} justifyContent={'center'}> */}
          {/*     <Typography>You have successfully confirmed received amount.</Typography> */}
          {/*   </Grid> */}
          {/* ) : ( */}
          <Grid item xs={12} display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <Grid item xs={2}>
              <Typography variant={'inherit'}>Amount</Typography>
            </Grid>
            <Grid item xs={3}>
              <InputField inputName={'amount'} inputType={'text'} width={140} marginBottom={'0px'} />
            </Grid>
          </Grid>
          {/* } */}
          {isLoadingConfirmReceivedAmount && <Loader />}
          {/* {confirmReceivedAmountData && !confirmReceivedAmountData?.data?.success && ( */}
          {/*   <Grid item xs={12} display={'flex'} alignItems={'center'} justifyContent={'center'} padding={'16px'}> */}
          {/*     <Typography variant={'h5'} color={'red'}> */}
          {/*       An error occurred while confirming the received amount. */}
          {/*     </Typography> */}
          {/*   </Grid> */}
          {/* )} */}
        </Grid>
      </FormProvider>
    </Modal>
  )
}
